import {setCookie, smoothScrollTo} from "./utils/Utils.js";

// Menu
import Menu1 from "./components/menu/Menu1.js";

// Core blocks
import Video from "./components/core-blocks/Video.js";
import VimeoEmbed from "./components/core-blocks/VimeoEmbed.js";
import YouTubeEmbed from "./components/core-blocks/YouTubeEmbed.js";
import ImageAlignFull from "./components/core-blocks/ImageAlignFull.js";

// ACF blocks
import Cases from "./components/acf-blocks/Cases.js";
import Slideshow from "./components/acf-blocks/Slideshow.js";

// Cookie Compliance
import CookieCompliance from "./components/cookie-compliance/CookieCompliance.js";

// Animation
import Anim01 from "./components/animation/Anim01.js";
import HeaderScroll from "./components/header/HeaderScroll.js";

//
// Manage vh unit
const setAppHeights = () => {
	const vh = window.innerHeight * .01;
	document.documentElement.style.setProperty('--vh', `${vh/10}rem`);
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight/10}rem`);
};
window.addEventListener('resize', setAppHeights)
setAppHeights();

//
// Enable event listener for pushState
const _wr = (type) => {
	const orig = history[type];
	return function() {
		const rv = orig.apply(this, arguments);
		const e = new Event(type);
		e.arguments = arguments;
		window.dispatchEvent(e);
		return rv;
	};
};
history.pushState = _wr('pushState');
history.replaceState = _wr('replaceState');

//
// Blocks
document.querySelectorAll('.wp-block-embed-vimeo').forEach(block => new VimeoEmbed(block));
document.querySelectorAll('.wp-block-embed-youtube').forEach(block => new YouTubeEmbed(block));
document.querySelectorAll('.wp-block-video-wrapper').forEach(domEl => new Video(domEl));
document.querySelectorAll('.wp-block-group .wp-block-image-wrapper.alignfull').forEach(domEl => new ImageAlignFull(domEl));

document.querySelectorAll('.acf-block-cases-list').forEach(domEl => new Cases(domEl));
document.querySelectorAll('.acf-block-slideshow').forEach(domEl => new Slideshow(domEl));

//
// Menus + Header
new Menu1();
if(document.body.classList.contains('single-post')) {
	const menuItemPosts = document.querySelectorAll('#menu-1-overlay .menu_page-posts, #menu-1-footer .menu_page-posts');
	if(menuItemPosts) {
		menuItemPosts.forEach(menuItem => menuItem.classList.add('js-active'));
	}
}
HeaderScroll();

//
// Cookie Compliance
new CookieCompliance();

//
// Animation
new Anim01();

const playVBKAnimation = () => {
	setTimeout(() => document.body.classList.add('has-vbk-animation-step-2'), 800);
	setTimeout(() => {
		document.body.classList.remove('has-vbk-animation-step-1');
		document.body.classList.remove('has-vbk-animation-step-2');
	}, 1500);
	if(document.body.classList.contains('page-template-page-home') && document.body.classList.contains('has-vbk-animation-step-1')) {
		setCookie('vbk24-animation-completed', true, 1); // 4320 = 1/2 year
	}
}
if(window.Cookiebot && window.location.hostname !== 'localhost') {
	window.addEventListener('CookiebotOnConsentReady', playVBKAnimation);
}
else {
	playVBKAnimation();
}

if(document.body.classList.contains('page-template-page-home') && document.body.classList.contains('has-vbk-animation-step-1')) {
	smoothScrollTo(0, 300);
}

//
// Scroll to #hash element
const scrollToHashElement = () => {
	const hash = window.location.hash;
	if(hash) {
		const id = hash.substring(1);
		const targetElement = document.querySelector(`#${id}`);
		if(targetElement) {
			const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - document.querySelector('#the-header').offsetHeight - 50;
			smoothScrollTo(targetPosition, 500);

			// Remove the hash from the URL without affecting the scroll position
			history.replaceState(null, null, ' ');
		}
	}
};
scrollToHashElement();
window.addEventListener('hashchange', scrollToHashElement);